import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  Checkbox,
  Col,
  Row,
  Typography,
  Breadcrumb,
  Form,
  Button,
  Spin,
} from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import { t } from "i18next";
import { getRequest, postRequest } from "../../axios"; // replace with your Axios helper
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import ButtonField from "../../common/htmlComponents/ButtonField";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";

const { Title } = Typography;

export default function CreatePRPage() {
  const [selectedCategory, setSelectedCategory] = useState(1);
  const [selectedCategoryName, setSelectedCategoryName] = useState("Cement");

  const [siteName, setSiteName] = useState([]);
  const [checkedSites, setCheckedSites] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const formRef = useRef();
  const { id, prId } = useParams();
  const CompanyID = authUserData()?.company;
  const [apiLoading, setapiLoading] = useState(false);
  const [categoryTreeData, setCategoryTreeData] = useState([]);
  const navigate = useNavigate();

  const handleCategoryClick = (key) => {
    setSelectedCategory(key.id);
    setSelectedCategoryName(key.name)
  };

  const onCheckAllChange = (e) => {
    const checked = e.target.checked;
    const allSites = siteName.map((item) => item.site_name);
    setCheckedSites(checked ? allSites : []);
    setCheckAll(checked);
  };

  const getSiteName = async () => {
    try {
      const res = await getRequest(
        `delivery-address/${CompanyID}/address-by-company/`
      );
      if (res.data?.data) {
        setSiteName(res.data.data);
      } else {
        ErrorNotificationMsg(t("error_in_company_adress_list"));
      }
    } catch (error) {
      console.error("Site fetch error:", error);
    }
  };

  const Categorytree = async () => {
    setapiLoading(true);
    try {
      const response = await getRequest("category-tree");
      const data = response.data?.results?.data || [];

      const filteredData = data.filter(
        (item) => item.unit_of_measurement !== "KG"
      );
      const sortedData = filteredData.sort((a, b) => a.id - b.id);

      setCategoryTreeData(sortedData);
    } catch (error) {
      console.error("Category tree fetch error:", error);
    } finally {
      setapiLoading(false);
    }
  };

  useEffect(() => {
    Categorytree();
    if (siteName.length === 0) getSiteName();
  }, []);

  const groupedSites = siteName.reduce((acc, item) => {
    if (!acc[item.city_name]) acc[item.city_name] = [];
    acc[item.city_name].push(item.site_name);
    return acc;
  }, {});

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);

      const selectedSites = siteName.filter((site) =>
        checkedSites.includes(site.site_name)
      );

      const payload = {
        company: CompanyID,
        category: selectedCategory,
        sites: selectedSites.map((e) => e.id),
      };


      const response = await postRequest("purchase-requisition/", payload);

      if (response.data.success) {
        SuccessNotificationMsg(response.data.message);
        navigate(`/purchase-requisition/sites/new/${selectedCategory}/`);
      } else {
        ErrorNotificationMsg(response.data.message || "Failed to create PR");
      }
    } catch (error) {
      console.error("Submission error:", error);
      ErrorNotificationMsg("Something went wrong while submitting PR.");
    } finally {
      setBtnLoading(false);
    }
  };

  const handleNext = () => {
    console.log("selectedCategoryww", selectedCategory);
    
    const selectedSites = siteName.filter((site) =>
      checkedSites.includes(site.site_name)
    );

    if (selectedSites.length === 0) {
      ErrorNotificationMsg("Please select at least one site before proceeding");
      return;
    }

    if(selectedCategoryName === "Cement" || selectedCategoryName === "Sand" || selectedCategoryName === "Aggregate" || selectedCategoryName === "Earthing"){
      navigate(`/purchase-requisition/sites/new/${selectedCategory}/`,{
        state: {
          categoryId: selectedCategory,
          siteIds: selectedSites.map((e) => e.id),
          selectedCategoryName: selectedCategoryName
        },
      });
    } else {
      navigate(`/purchase-requisition/sites/new/2/`, {
        state: {
          categoryId: selectedCategory,
          siteIds: selectedSites.map((e) => e.id),
          selectedCategoryName: selectedCategoryName
        },
      });
    }
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Create New PR</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/purchase-requisition-history">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Create New PR</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
     
        <div className="stepscontentwrap">
        <SubscriptionNotification />
        <div className="stepsContent">
            <Row gutter={16} style={{marginBottom:'16px'}}>
              {categoryTreeData.map((cat) => (
                <Col key={cat.id}>
                  <Card
                    hoverable
                    style={{
                      width: 160,
                      height: 180,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      border:
                        selectedCategory === cat.id
                          ? "2px solid #1677ff"
                          : "1px solid #d9d9d9",
                    }}
                    onClick={() => handleCategoryClick(cat)}
                  >
                    <img
                      src={cat.image}
                      alt={cat.name}
                      style={{ height: 80, objectFit: "contain" }}
                    />
                    <div style={{ marginTop: 12, fontWeight: 500 }}>
                      {cat.name}
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>

            {/* Site Selection */}
            <Form
              ref={formRef}
              autoComplete="off"
              layout="vertical"
              
              // onFinish={handleSubmit} 
            >
              
                <Spin spinning={apiLoading}>
              <Checkbox  className="custmochekc"
                indeterminate={
                  checkedSites.length > 0 &&
                  checkedSites.length < siteName.length
                }
                onChange={onCheckAllChange}
                checked={checkAll}
              >
                Select All Sites
              </Checkbox>
              <div style={{ backgroundColor: "#eaf3ff" }}>
                <Checkbox.Group
                  style={{ width: "100%", margin: "10px" }}
                  value={checkedSites}
                  onChange={(val) => {
                    setCheckedSites(val);
                    setCheckAll(val.length === siteName.length);
                  }}
                >
                  {Object.entries(groupedSites).map(([city, sites]) => (
                    <div key={city} style={{ marginTop: 16 }}>
                      <strong>{city}</strong>
                      <Row gutter={[8, 8]}>
                        {sites.map((site) => (
                          <Col key={site}>
                            <Checkbox value={site}>{site}</Checkbox>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  ))}
                </Checkbox.Group>
              </div>
              </Spin>
           
         
            </Form>
              
        </div>
           <div className="FormFooter bidftr" style={{padding:'16px  ', margin:'0'}}>
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="submit"
                  label="Next"
                  loading={btnLoading}
                  //   disabled={disabled}
                  onClick={handleNext}
                />
              </div>
         </div>
      
    </>
  );
}

